class JobExecutor {
  private concurrency: number = 5
  private queue: any[]
  private jobSet: Set<string>
  private running: number

  constructor(concurrency?: number) {
    this.concurrency = concurrency || 5
    this.queue = []
    this.jobSet = new Set()
    this.running = 0
  }

  enqueue(id: string, req: any) {
    if (!id) return
    if (this.jobSet.has(id)) {
      // duplicate
      return
    }
    this.jobSet.add(id)
    return new Promise((resolve, reject) => {
      this.queue.push(() => {
        return Promise.resolve()
          .then(req)
          .then(v => {
            return Promise.resolve()
              .then(() => {
                if (id) {
                  this.jobSet.delete(id)
                }
                return v
              })
          })
          .then(resolve, reject)
      })
      this._loop()
    })
  }

  private _loop() {
    while (this.running < this.concurrency && this.queue.length) {
      const job = this.queue.shift()
      if (job) {
        this.running += 1
        job().then(() => {
          this.running -= 1
          this._loop()
        })
      }
    }
  }
}

export default JobExecutor
